export enum CustomerFeatureEnum {
  ASSIGNMENTS = "assignments",
  PROJECTS = "projects",
  ATTACHMENTS = "attachments",
  KAR = "kar"
}
